import { Drawer } from '@material-ui/core'
import { useUser } from 'components/providers/UserProvider'
import { useAppContext } from 'lib/hooks'
import { useMobileSidebarStore } from 'lib/hooks/useMobileSidebarStore'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PurchaseChangeLogsPresenter } from './PurchaseChangeLogsPresenter'
import { PurchaseEventPresenter } from './PurchaseEventPresenter'
import { Settings } from './Settings'
import './taxation-presenter.css'
import { TaxationSidebar } from './TaxationSidebar'

export type TaxationSidebarTab = 'purchases' | 'logs'

export const TaxationPresenter = (): JSX.Element => {
  const { t } = useTranslation()
  const { hasPermission } = useUser()
  const { isMobile } = useAppContext()
  const showSidebar = hasPermission('use_internal_tools')
  const [activeSidebarTab, setActiveSidebarTab] = useState<TaxationSidebarTab>('purchases')
  const [sidebarTab, setSidebarTab] = useState<any[]>([])
  const mobileSidebar = useMobileSidebarStore()

  useEffect(() => {
    const newSidebarTabs = []
    newSidebarTabs.push({
      tab: 'purchases',
      transKey: t('taxation.purchaseEventsTab'),
      disabled: false,
      disabledTooltip: null,
      dataTestid: 'purchases',
    })

    if (hasPermission('use_internal_tools'))
      newSidebarTabs.push({
        tab: 'logs',
        transKey: t('taxation.logsTab'),
        disabled: false,
        disabledTooltip: null,
        dataTestid: 'logs',
      })

    setSidebarTab(newSidebarTabs)
  }, [])

  const changeSidebarTab = (tab: TaxationSidebarTab): void => {
    setActiveSidebarTab(tab)
    if (isMobile) mobileSidebar.setTaxation(false)
  }

  const returnPageContentAccordingSelectedSidebarTab = (activeTab: string) => {
    switch (activeTab) {
      case 'purchases': {
        return <PurchaseEventPresenter />
      }
      case 'logs': {
        return <PurchaseChangeLogsPresenter />
      }
      default:
        return <Settings />
    }
  }

  return (
    <div className="d-flex flex-row">
      {showSidebar && !isMobile && (
        <div
          className="d-flex justify-content-center align-items-start"
          style={{ marginRight: 16 }}
        >
          <TaxationSidebar
            onTabChange={changeSidebarTab}
            tabs={sidebarTab}
            activeTab={activeSidebarTab}
          />
        </div>
      )}
      {showSidebar && isMobile && (
        <Drawer
          anchor="left"
          open={mobileSidebar.taxation}
          onClose={() => mobileSidebar.setTaxation(false)}
        >
          <TaxationSidebar
            onTabChange={changeSidebarTab}
            tabs={sidebarTab}
            activeTab={activeSidebarTab}
          />
        </Drawer>
      )}
      {returnPageContentAccordingSelectedSidebarTab(activeSidebarTab)}
    </div>
  )
}
